export const getSelectedIds = (selected) => {
  if (!selected || typeof selected !== 'object') return [];
  if (selected === true) return [];

  return Object.keys(selected)
    .filter(key => selected[key])
    .map(Number);
};

export const getSelectedCount = (selected) => {
  if (!selected) return 0;
  if (selected === true) return -1;

  return Object.keys(selected).filter(key => selected[key]).length;
};

export const transformSelection = (selected) => {
  if (!selected || selected === true) return selected;

  const transformed = {};
  Object.keys(selected).forEach(key => {
    if (selected[key]) {
      transformed[key] = true;
    }
  });
  return transformed;
};

export const formatApiUrl = (baseUrl, params = {}) => {
  const queryParams = new URLSearchParams();

  Object.keys(params).forEach(key => {
    const value = params[key];
    if (value !== null && value !== undefined && value !== '') {
      queryParams.append(key, value);
    }
  });

  const queryString = queryParams.toString();
  return queryString ? `${baseUrl}?${queryString}` : baseUrl;
};

export const debounce = (func, delay = 500) => {
  let timeoutId;
  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func(...args), delay);
  };
};

export const getUnselectedIds = (unselected) => {
  if (!unselected || typeof unselected !== 'object') return [];

  return Object.keys(unselected)
    .filter(key => unselected[key])
    .map(Number);
};

export const isAllSelected = (selectionRef) => {
  return selectionRef?.selected === true;
};
